export const userRoleSelector = (state) => state.auth.userRole.alias;
export const translateSelector = (state) => state.status.translate;
export const learningCentersSelector = (state) => state.common.learningCenters;
